/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 *
 */

import React from 'react';

export default class NotAuthenticated extends React.Component{
  state ={
    isAuthenticated: false
    }

  render() {
    return null;
  }

}